import { render, staticRenderFns } from "./CustomerAppointmentDetail.vue?vue&type=template&id=1e2631d8&"
import script from "./CustomerAppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerAppointmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports